import { useSelector } from 'react-redux'
import RootState from 'store/state'

export default function useSettings(): RootState['settings'] {
    const settings = useSelector<RootState, RootState['settings']>(({ settings }) => settings ?? {})

    return settings
}
